import React from 'react';
import { FaPlay } from "react-icons/fa";
import './cardComponent.css'

interface CardProps {
  point: string;
  isLast: boolean;
  distanceToNext: number;
}

const CardComponent: React.FC<CardProps> = ({ point, isLast, distanceToNext }) => {
  return (
    <div className="card-wrapper">
      <div
        className="card-box"
      >
        <h3 style={{ margin: '0 0 8px', fontSize: 18, color: 'rgb(94,195,52)' }}>
          {point}
        </h3>
        <p style={{ margin: 0, color: '#666' }}>
          {isLast ?
            <>
              <span>Fin del trayecto</span> <br />
            </>
            : null}
          {distanceToNext.toFixed(2)} km

        </p>
      </div>
      {isLast ? null : <FaPlay />}
    </div>
  );
};

export default CardComponent;
